export default __webpack_public_path__ + "static/media/ET3.cc65039e.png";